var _circle, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconXInCircle = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  className: "icon icon--x-in-circle",
  ref: svgRef
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 10
})), _line || (_line = /*#__PURE__*/React.createElement("line", {
  x1: 15,
  y1: 9,
  x2: 9,
  y2: 15
})), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
  x1: 9,
  y1: 9,
  x2: 15,
  y2: 15
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconXInCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/IconXInCircle.1bf5547b.svg";
export { ForwardRef as ReactComponent };